import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Engagement from "../components/engagement/Engagement";
import { useLocation, useParams } from "react-router-dom";

// Enagementpage component renders the engagement interface with a sidebar and engagement content.
// It receives an openDrawer prop to control the sidebar drawer and extracts route parameters and user data.
const Enagementpage = ({ openDrawer }) => {
  // useParams hook provides access to route parameters (e.g., clientId in this case).
  const params = useParams();

  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // engagementData object contains information specific to the engagement page, such as client_id and UI state.
  const engagementData = {
    client_id: params.clientId, // Client ID extracted from the route parameters
    isSearchFilterVisible: true, // Boolean flag to control the visibility of search filters
    dashboard: false, // Boolean flag to indicate whether the dashboard view is enabled
  };

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (4 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={5} />

      {/* Engagement component that renders the main content for the engagement page. 
          It receives the openDrawer, userData, and engagementData props. */}
      <Engagement
        openDrawer={openDrawer}
        userData={UserData}
        engagementData={engagementData}
      />
    </>
  );
};

export default Enagementpage;
